/* istanbul ignore file */
import { CMSMenuPanel } from './CMSMenuPanel';

export default CMSMenuPanel;
